export default __webpack_public_path__ + "static/media/CovidApp.b036d314.webp";